
export const badge = {
    "pending": "bg-pending",
    "freeze pending": "bg-pending",
    "unfreeze pending": "bg-pending",
    "rejected": "bg-red",
    "failed": "bg-red",
    "suspended": "bg-red",
    "cancelled": "bg-red",
    "under maintenance": "pending-bg",
    "unfreeze": "bg-freeze",
    "unfreezed": "bg-freeze",
    "freezed": "bg-freeze",
    "active": "bg-green",
    "inactive": "bg-red",
    "approved": "bg-green",
    "freeze failed": "bg-red",
    "unfreeze failed": "bg-red",
    "reviewing": "bg-consume",
    "success": "bg-green",
    "consume": "bg-consume",
    "fail": "bg-red",
    "cancel": "bg-red",
    "kycrejected": "bg-red",
    "kycpending": "bg-pending", 
    "freeze": "bg-pending",
    "reopened": "bg-pending",
    "submitted": "bg-pending"
}


export const badgeColor = {
     approved: "badge-green text-btntextColor", 
     pending: "badge-pending", 
     failed: "badge-red text-btntextColor", 
     rejected: "badge-red text-btntextColor", 
     freeze: "badge-pending", 
     consume: "badge-consume", 
     fail: "badge-red text-btntextColor", 
     "under review": "badge-under-review", 
     registered: "badge-consume", 
     "approval in progress": 
     "badge-approval-inprogress", 
 }
